import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiContentGeneratorInnerComponent } from '../ai-content-generator-inner/ai-content-generator-inner.component';
import { UtilitiesService } from 'src/app/core/utilities.service';
@Component({
  selector: 'ai-content-generator',
  templateUrl: './ai-content-generator.component.html',
  styleUrls: ['./ai-content-generator.component.scss'],
})
export class AiContentGeneratorComponent implements OnInit {
  @Input() output: string = undefined;
  @Output() outputChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    private utils: UtilitiesService
  ) {}

  public input: any = {};

  ngOnInit() {
    this.utils.aiContentGenerator = this;
  }

  public show(templateName, presetParams, onChangeCallback) {
    this.utils.aiContentGenerator.input.templateName = templateName;
    this.utils.aiContentGenerator.input.onChange = onChangeCallback;
    this.utils.aiContentGenerator.input.presetParams = presetParams;

    const modalRef = this.modalService.open(AiContentGeneratorInnerComponent, {
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.id = 11;
    modalRef.result
      .then((result) => {
        if (result != 'Modal Closed') {
          this.output = result;
          this.outputChange.emit(result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  clearSelected() {
    this.output = '';
    this.outputChange.emit('');
  }
}
